

const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_API_BASE_URL || '/v1/api',
  TIMEOUT: 1000,
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

export default API_CONFIG